import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { Link } from "react-router-dom";

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-dark-bg">
      <Navbar />
      <main>
        {/* Header */}
        <section className="pt-28 md:pt-36 pb-12 md:pb-16 bg-dark-bg">
          <div className="w-full px-6 md:px-10 lg:px-16 max-w-4xl">
            <p className="text-xs md:text-sm font-sans font-semibold tracking-[0.2em] text-gold uppercase mb-4">
              Get in Touch
            </p>
            <h1 className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-medium text-charcoal-50 leading-tight tracking-tight-xl">
              Start your journey to pure water
            </h1>
          </div>
        </section>

        {/* Contact Grid */}
        <section className="pb-24 md:pb-32 bg-dark-bg">
          <div className="w-full px-6 md:px-10 lg:px-16">
            <div className="flex flex-col lg:flex-row gap-12 lg:gap-16">
              {/* Contact Info */}
              <div className="lg:w-2/5">
                <div className="flex flex-col gap-8">
                  <div>
                    <h3 className="font-serif text-xl font-semibold text-charcoal-50 mb-3">
                      Schedule a Consultation
                    </h3>
                    <p className="text-sm text-charcoal-300 font-sans leading-relaxed mb-4">
                      We will visit your home, test your water, and recommend the
                      perfect system — no cost or obligation.
                    </p>
                  </div>

                  <div className="flex flex-col gap-6">
                    <div className="flex items-start gap-4">
                      <div className="w-10 h-10 rounded-full bg-gold/10 flex items-center justify-center flex-shrink-0 border border-gold/20">
                        <i className="ri-phone-line text-gold"></i>
                      </div>
                      <div>
                        <p className="text-xs font-sans font-semibold tracking-wide text-charcoal-400 uppercase mb-1">
                          Phone
                        </p>
                        <p className="text-base text-charcoal-50 font-sans">
                          (515) 207-0355
                        </p>
                      </div>
                    </div>

                    <div className="flex items-start gap-4">
                      <div className="w-10 h-10 rounded-full bg-gold/10 flex items-center justify-center flex-shrink-0 border border-gold/20">
                        <i className="ri-mail-line text-gold"></i>
                      </div>
                      <div>
                        <p className="text-xs font-sans font-semibold tracking-wide text-charcoal-400 uppercase mb-1">
                          Email
                        </p>
                        <a
                          href="mailto:info@proprepurification.com"
                          className="text-base text-charcoal-50 font-sans hover:text-gold transition-colors duration-300"
                        >
                          info@proprepurification.com
                        </a>
                      </div>
                    </div>

                    <div className="flex items-start gap-4">
                      <div className="w-10 h-10 rounded-full bg-gold/10 flex items-center justify-center flex-shrink-0 border border-gold/20">
                        <i className="ri-map-pin-line text-gold"></i>
                      </div>
                      <div>
                        <p className="text-xs font-sans font-semibold tracking-wide text-charcoal-400 uppercase mb-1">
                          Service Area
                        </p>
                        <p className="text-base text-charcoal-50 font-sans">
                          Greater Des Moines Area
                        </p>
                      </div>
                    </div>

                    <div className="flex items-start gap-4">
                      <div className="w-10 h-10 rounded-full bg-gold/10 flex items-center justify-center flex-shrink-0 border border-gold/20">
                        <i className="ri-time-line text-gold"></i>
                      </div>
                      <div>
                        <p className="text-xs font-sans font-semibold tracking-wide text-charcoal-400 uppercase mb-1">
                          Hours
                        </p>
                        <p className="text-base text-charcoal-50 font-sans">
                          Mon – Fri: 10am – 5pm
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Consultation Card */}
              <div className="lg:w-3/5">
                <div className="bg-dark-surface border border-dark-border rounded-2xl p-6 md:p-8 lg:p-10">
                  <div className="w-14 h-14 rounded-full bg-gold/10 flex items-center justify-center mb-6 border border-gold/20">
                    <i className="ri-calendar-check-line text-gold text-2xl"></i>
                  </div>
                  <h3 className="font-serif text-xl font-semibold text-charcoal-50 mb-6">
                    Consultation Request Form
                  </h3>
                  <a
                    href="https://proprepurification.hbportal.co/public/6a12253286f7e2b6d0c13a0f/1-Inquiry_form"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 px-6 py-3 bg-gold text-dark-bg text-sm font-sans font-semibold rounded-full hover:bg-gold-light transition-colors duration-300 whitespace-nowrap"
                  >
                    Inquire
                    <i className="ri-arrow-right-line text-xs"></i>
                  </a>
                  <p className="text-xs text-charcoal-400 font-sans mt-6 leading-relaxed">
                    For urgent questions, please call us directly at{" "}
                    <a href="tel:+15152070355" className="text-gold hover:underline">
                      (515) 207-0355
                    </a>
                    .
                  </p>
                  <div className="mt-6 pt-6 border-t border-dark-border">
                    <p className="text-xs text-charcoal-400 font-sans leading-relaxed">
                      Your information is handled responsibly. Read our{" "}
                      <Link
                        to="/privacy"
                        className="text-gold hover:underline"
                      >
                        Privacy Policy
                      </Link>{" "}
                      to learn how we protect your data.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}